import { ObjectKeys } from "@/utils/object.utils";

import { projectIs, siteEnvIs } from "./featureFlagsDeside.helpers";

export const featureFlagsConfig = {
  UI_KIT_PAGE: siteEnvIs(["tgb"]) || process.env.SITE_ENV === "local",
  NEW_LEFTBAR_DESIGN: siteEnvIs(["tgb", "pre", "prod"]),

  // Banners //
  HALLOWEEN_THEME: siteEnvIs([]),
  BLACK_FRIDAY_THEME: siteEnvIs([]),
  CHRISTMAS_THEME: siteEnvIs([]),
  ELEVEN_YEARS_THEME: siteEnvIs([]),
  VALENTINES_DAY_THEME: siteEnvIs([]),
  // ------- //

  // Golden meets //
  LEFTBAR_SOH_HIDDEN: projectIs(["GM"]),
  LEFTBAR_ELEVEN_YEARS_ICON_HIDDEN: projectIs(["GM"]),
  LADY_CARD_INTRO_BADGE_HIDDEN: projectIs(["GM"]),
  LADY_CARD_VIEW_VIDEO_BUTTON_HIDDEN: projectIs(["GM"]),
  // -----------  //
};

export const featureFlagsConstants = ObjectKeys(featureFlagsConfig);
export type FeatureFlagsConstants = (typeof featureFlagsConstants)[number];
